module.exports = __webpack_public_path__ + "img/ng1-2.5704eccb.jpg";